import { useModal } from 'context/Modal/Context';
import { MODAL_NAME } from 'context/Modal/MODAL_NAME';
import { ZoomSliderProps } from 'context/Modal/views/ZoomSlider';
import { PropsWithChildren } from 'react';

type ZoomButtonBaseProps = {
  className?: string;
} & Omit<ZoomSliderProps, 'closeModal'>;

const ZoomButton = ({ children, className, ...modalProps }: PropsWithChildren<ZoomButtonBaseProps>) => {
  const { openModal } = useModal();
  const handleOpenCardZoom = () => {
    openModal(MODAL_NAME.ZOOM_SLIDER, modalProps);
  };

  return (
    <button className={className} onClick={handleOpenCardZoom} type="button">
      {children}
    </button>
  );
};

export default ZoomButton;
